import './Hero.css'

function Hero({ children }) {
    return (
        <section className="hero">
            {children}
        </section>
    )
}

export default Hero